import moment from "moment";
const initialState = {
  selectOptions: [
    { name: "LAST 7 DAYS", id: 7 },
    { name: "LAST 14 DAYS", id: 14 },
    { name: "LAST 21 DAYS", id: 21 },
    { name: "LAST 30 DAYS", id: 30 },
    { name: "LAST 60 DAYS", id: 60 },
    { name: "LAST 90 DAYS", id: 90 },
    { name: "LAST 120 DAYS", id: 120 },
    { name: "CUSTOM PERIOD", id: 1 },
  ],
  filterStartDate: moment().subtract(29, "days").startOf("day"),
  filterEndDate: moment(),
  isCustom: false,
  interval: 30,
};
/**
 * teporary save the state of passwords if user change his password
 * @param {object} state
 * @param {object} action
 */
const diaryReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CHANGE_CUSTOM_FILTER_DATE":
      return { ...state, isCustom: action.payload.isCustom, filterStartDate: action.payload.filterStartDate, filterEndDate: action.payload.filterEndDate };

    case "CHANGE_DATE_INTERVAL":
      return { ...state, interval: action.payload.interval };

    default:
      return state;
  }
};

export default diaryReducer;
